import { render } from "./ListeModeleSignataire.vue?vue&type=template&id=ffa78b00&ts=true"
import script from "./ListeModeleSignataire.vue?vue&type=script&lang=ts"
export * from "./ListeModeleSignataire.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__